import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getMembershipFeeSetting,
  saveMembershipFeeSetting,
} from "../../../../store/actions/councilActions/membershipFeeAction";
import { errorAlert } from "../../../../utils/alert";

const EMPTY = {
  individual_1y: "",
  individual_lifetime: "",
  other_1y: "",
  other_lifetime: "",
};

/*
 * Admin sets the four membership fees. Members pick a plan (1 Year / Lifetime)
 * on the registration form and pay the matching figure through the gateway.
 */
const MembershipFeeList = () => {
  const dispatch = useDispatch();
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setLoading(true);
    const s = await dispatch(getMembershipFeeSetting());
    if (s) {
      setForm({
        individual_1y: s.individual_1y ?? "",
        individual_lifetime: s.individual_lifetime ?? "",
        other_1y: s.other_1y ?? "",
        other_lifetime: s.other_lifetime ?? "",
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const num = (v) => (v === "" || v === null ? 0 : Number(v));

  const submit = async (e) => {
    e.preventDefault();
    for (const k of Object.keys(EMPTY)) {
      if (form[k] === "" || Number(form[k]) < 0) {
        return errorAlert("Please enter all four fees (0 or more).");
      }
    }
    setBusy(true);
    const body = new FormData();
    Object.keys(EMPTY).forEach((k) => body.append(k, num(form[k])));
    await dispatch(saveMembershipFeeSetting(body));
    setBusy(false);
    load();
  };

  const field = (label, key) => (
    <div className="form-group col-md-6">
      <label>
        {label} <span className="text-danger">*</span>
      </label>
      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text">₹</span>
        </div>
        <input
          type="number"
          min={0}
          className="form-control"
          placeholder="0"
          value={form[key]}
          onChange={(e) => setForm({ ...form, [key]: e.target.value })}
          required
        />
      </div>
    </div>
  );

  return (
    <div className="content d-flex flex-column flex-column-fluid">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-9">
            <div className="BigTitle mb-3">Membership Fees</div>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <form onSubmit={submit}>
                <h5 className="mb-2" style={{ color: "#1f3c88" }}>
                  Individual Membership
                </h5>
                <div className="row">
                  {field("Individual - 1 Year", "individual_1y")}
                  {field("Individual - Lifetime", "individual_lifetime")}
                </div>

                <h5 className="mb-2 mt-3" style={{ color: "#1f3c88" }}>
                  Other (Organisation) Membership
                </h5>
                <div className="row">
                  {field("Other - 1 Year", "other_1y")}
                  {field("Other - Lifetime", "other_lifetime")}
                </div>

                <button
                  type="submit"
                  className="btn btn-primary mt-3"
                  disabled={busy}
                >
                  {busy ? "Saving..." : "Save Fees"}
                </button>
                <small className="form-text text-muted mt-2">
                  A member chooses 1 Year or Lifetime on the registration form
                  and pays the matching fee. 1-Year membership is valid for a
                  year from payment; Lifetime never expires.
                </small>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipFeeList;
